import React from 'react'
import { Text } from '../Text/component'
import { IProps } from './index'

export const PriceForPeriod = (props: IProps) => {
  const { price, simple, small, subText } = props
  const introText = props.introText || 'from'
  const periodText = props.periodText || 'mo'
  return (
    <div className="monthly-price">
      <div className="monthly-price-bottom-row">
        {!simple && (
          <Text brand="default" size="body">
            {introText}&nbsp;{' '}
          </Text>
        )}
        <Text brand="default" size={small ? 'body' : 'caption'}>
          ${price}
        </Text>
        <Text brand="default" size="body">
          /{periodText}
        </Text>
      </div>
      {subText && (
        <div className="monthly-price-subtext">
          <Text brand="default" size="caption">
            {subText}
          </Text>
        </div>
      )}
      <style jsx>
        {`
          .monthly-price {
            display: grid;
            grid-template-rows: auto;
            word-break: break-word;
          }

          .monthly-price-top-row {
            grid-row: 1;
          }

          .monthly-price-bottom-row {
            grid-row: 2;
          }
        `}
      </style>
    </div>
  )
}
